import { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { signOut } from 'firebase/auth';

import { auth } from '../firebase_config';

import { NavBar } from './NavBar';
import { MediaPlayer } from './MediaPlayer';
import { BurgerIcon } from './SvgComponents/BurgerIcon';
import { CloseIcon } from './SvgComponents/CloseIcon';
import { LogOutIcon } from './SvgComponents/LogoutIcon';
import { ProfileIcon } from './SvgComponents/ProfileIcon';
import { ModalWindow } from './ModalWindow';
import { SearchBar } from './SearchBar';

import { UserContext } from '../Pages/UserContext';

import { toast } from 'react-toastify';

export const Header = () => {
  const { user, userName, count, sum, setCount, setSum, setCart } = useContext(UserContext);
  const navigate = useNavigate();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isUserOpen, setUserOpen] = useState(false);
  const [isModalOpened, setOpenModal] = useState(false);

  const handleLogOut = () => {
    setOpenModal(false);
    signOut(auth)
      .then(() => {
        navigate('/', { replace: true });
        toast('🧙we will miss you !');
        setUserOpen(false);
        setMenuOpen(false);
      })
      .then(() => {
        setCart([]);
        setSum(0);
        setCount(0);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setUserOpen(false);
  };

  const toggleUsermenu = () => {
    setUserOpen((isUserOpen) => !isUserOpen);
  };

  const closeUsermenu = () => {
    setUserOpen(false);
    setMenuOpen(false);
  };

  const handleSearch = () => {
    setMenuOpen(false);
    setUserOpen(false);
  };

  return (
    <header className="w-full bg-background relative">
      <div className="px-4 md:px-10 lg:px-24 py-2 md:py-4 m-auto flex justify-between max-w-108">
        <div className="flex flex-col gap-4 order-3 table:order-1">
          <div className="flex gap-4">
            <MediaPlayer />
            <button className="inline-block md:hidden z-50" onClick={() => setMenuOpen(!isMenuOpen)}>
              {isMenuOpen ? <CloseIcon /> : <BurgerIcon />}
            </button>
          </div>
          <hr className="hidden md:inline-block h-01 border-none bg-gradient-to-r from-grStart to-grEnd" />
          <NavBar isOpen={isMenuOpen} handleClick={closeMenu} />
        </div>
        <Link className="order-1 table:order-2" to="/" onClick={closeUsermenu}>
          <img className="h-16 md:h-24" src="/Assets/Icons/Hogwarts.svg" alt="Hogwarts Logo" />
        </Link>
        <div
          className={[
            'absolute z-50 md:top-4 right-10 table:static flex flex-col gap-4 justify-center table:justify-start order-2 table:order-3 table:w-300 xl:w-450 duration-500',
            isMenuOpen ? 'top-16 opacity-100' : 'top-[-490px] md:top-6  opacity-0 md:opacity-100',
          ].join(' ')}>
          <div className="flex items-center justify-between">
            <q className="self-end hidden table:inline-block font-poppins font-normal table:text-sm xl:text-lg text-font tracking-widest leading-6">
              After all this time? Always...
            </q>
            <div className="mt-16 md:mt-0 border-2 border-borderColor rounded-full h-10 w-10 flex justify-center items-center relative">
              {user && userName ? (
                <button
                  className="cursor-pointer text-font hover:text-borderColor duration-500"
                  onClick={toggleUsermenu}>
                  {userName[0]}
                </button>
              ) : (
                <button
                  className="cursor-pointer text-font hover:text-borderColor duration-500"
                  onClick={toggleUsermenu}>
                  <ProfileIcon />
                </button>
              )}
              <div
                className={[
                  'absolute top-0 md:top-12 right-12 md:right-0 z-40 md:z-50 bg-font w-28 text-base font-poppins font-normal rounded-lg flex flex-col items-center justify-center gap-2 tracking-wide transition-all duration-300 ease-in-out',
                  isUserOpen ? 'opacity-100' : 'opacity-0',
                ].join(' ')}>
                {user ? (
                  <>
                    <Link
                      className="font-semibold text-background hover:text-borderColor duration-300"
                      to="/profile"
                      onClick={closeUsermenu}>
                      My profile
                    </Link>
                    <div className="flex flex-col justify-center font-crimson text-sm">
                      <span>{count} items in chest</span>
                      <span>{sum}£ to pay</span>
                    </div>
                    <hr className="w-full h-01 border-none bg-gradient-to-r from-grStart to-grEnd" />
                    <Link
                      className="cursor-pointer hover:text-borderColor duration-300 flex items-center self-start gap-2"
                      to="/cart"
                      onClick={closeUsermenu}>
                      <div className="w-5 h-5 bg-chest bg-cover bg-center bg-no-repeat"></div>
                      My chest
                    </Link>
                    <Link
                      className="cursor-pointer hover:text-borderColor duration-300 flex items-center self-start gap-1"
                      to="/wishlist"
                      onClick={closeUsermenu}>
                      <div className="w-5 h-5">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="fill-borderColor">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
                          />
                        </svg>
                      </div>
                      My wishes
                    </Link>
                    <button
                      className="cursor-pointer hover:text-borderColor duration-300 flex items-center self-start gap-1"
                      onClick={() => setOpenModal(true)}>
                      <LogOutIcon />
                      sign out
                    </button>
                  </>
                ) : (
                  <Link to="/profile" onClick={closeUsermenu}>
                    sign in
                  </Link>
                )}
              </div>
            </div>
          </div>
          <hr className="hidden table:inline-block h-01 border-none bg-gradient-to-l from-grStart to-grEnd" />
          <SearchBar onClose={handleSearch} />
        </div>
      </div>
      {isModalOpened && (
        <ModalWindow closeModal={() => setOpenModal(false)}>
          <div className="mt-10 flex flex-col gap-5 justify-center items-center p-3 smart:p-5 ">
            <h2 className="font-crimson font-bold text-lg md:text-xl leading-6 flex tracking-wider text-center">
              Are you leaving yet?
            </h2>
            <div className="flex gap-4 justify-center items-center">
              <button
                className="h-12 w-28 font-crimson font-normal text-lg leading-8 tracking-wider flex justify-center items-center duration-500 bg-transparent border-2 rounded-3xl border-borderColor hover:text-font hover:bg-borderColor"
                onClick={handleLogOut}>
                Yep
              </button>
              <button
                className="h-12 w-28 font-crimson font-normal text-lg leading-8 tracking-wider flex justify-center items-center duration-500 bg-transparent border-2 rounded-3xl border-borderColor hover:text-font hover:bg-borderColor"
                onClick={() => setOpenModal(false)}>
                Nope
              </button>
            </div>
          </div>
        </ModalWindow>
      )}
    </header>
  );
};
